// extracted by mini-css-extract-plugin
module.exports = {"textareaLabel":"TextAreaWithButton_textareaLabel__SKsRf","textareaButton":"TextAreaWithButton_textareaButton__2fGGT"};